module.exports = __webpack_public_path__ + "components/icon/static/moonrise-d1551ad7f10e08f0c2e514e39661e318.svg";